import React from 'react';
import Tilty from 'react-tilty';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

const SubmissionInfo = () => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/presale/submit');
    };

    return (
        <div style={{ marginTop: 80 }}>
            <h2 style={{ color: '#749d1a', fontSize: 55, marginBottom: 40 }}>Want Your Own Pool?</h2>
            <div className="row">
                <p style={{ color: '#ccc', fontSize: 30, lineHeight: 1.6 }}>
                    Are you a CT influencer, degen DAO, or just dangerously based? <br />
                    Apply to run your own pool and claim 1% of $OSCAR for rallying your community.<br />
                    Hype your tribe. Grow your army. Earn meme clout.
                </p>

            </div>
            <Tilty
                max={10}
                perspective={800}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#efbc00 !important',
                        color: '#000',
                        marginTop: 2,
                        fontSize: 'clamp(16px, 3vw, 25px)',
                        fontFamily: '"Winky Rough", sans-serif',
                        fontWeight: 600,
                        padding: '10px 20px',
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#efbc00 !important',
                            boxShadow: 'none'
                        },
                        '&:focus': {
                            backgroundColor: '#efbc00 !important'
                        },
                        '&:active': {
                            backgroundColor: '#efbc00 !important'
                        }
                    }}
                    onClick={handleButtonClick}
                >
                    APPLY FOR A COMMUNITY POOL
                </Button>
            </Tilty>
        </div>
    );
};

export default SubmissionInfo;
